import { render, staticRenderFns } from "./DashboardHandler.vue?vue&type=template&id=5b2d57aa&"
import script from "./DashboardHandler.ts?vue&type=script&lang=js&"
export * from "./DashboardHandler.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports